'use client';

import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { acceptedCookiePolicyAtom } from '~/atoms';
import { CookieStorageKey, DefaultAcceptedCookiePolicy } from './CookieBanner/constants';
import { AcceptedCookiePolicyType } from '~/types-and-enums/cookieTypes';

const CookieHandler = () => {
  const setCookiePolicy = useSetAtom(acceptedCookiePolicyAtom);

  useEffect(() => {
    const cookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${CookieStorageKey}=`));
    const policy = (cookie?.split('=')[1] ||
      DefaultAcceptedCookiePolicy) as AcceptedCookiePolicyType;
    setCookiePolicy(policy);
  }, [setCookiePolicy]);

  return null;
};

export default CookieHandler;
